export default __webpack_public_path__ + "static/media/img_08.b3794c58.jpg";